module.exports = __webpack_public_path__ + "media/images/icon__minus@2x-3263971f6d2bbbb8b880bf84726ded7c.png";